var _line, _g, _g2, _path, _line2, _g3, _g4, _line3, _g5, _g6, _path2, _line4, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingSequenceMeter = function SvgPHeatingSequenceMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 458.1,
    y1: 318.1,
    x2: 452.6,
    y2: 318.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440.6,
    y: 304.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.1,305.1v2h-14v-2H455.1 M456.1,304.1h-16v4h16V304.1L456.1,304.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440.6,
    y: 328.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.1,329.1v2h-14v-2H455.1 M456.1,328.1h-16v4h16V328.1L456.1,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 443.6,
    y: 307.6,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.1,308.1v20h-8v-20H452.1 M453.1,307.1h-10v22h10V307.1L453.1,307.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.6,328.1c-1.8-2.6-2.8-6.4-2.8-9.9s1-7.3,2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.5,328.1c1.8-2.6,2.8-6.4,2.8-9.9s-1-7.3-2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 458.6,
    y: 307.6,
    width: 21,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.1,308.1v20h-20v-20H479.1 M480.1,307.1h-22v22h22V307.1L480.1,307.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.5,315.1h1.1l-2,5.7h-1l-2-5.7h1.1l1.5,4.5L470.5,315.1z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 469.1,
    y1: 307.1,
    x2: 469.1,
    y2: 301.1,
    fill: "none",
    stroke: "#000000"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 474.1,
    y1: 339.1,
    x2: 474.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.5,334.6 474.1,329.1 472.6,334.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 464.1,
    y1: 339.1,
    x2: 464.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.5,334.6 464.1,329.1 462.6,334.6"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 388.1,
    y1: 318.1,
    x2: 382.6,
    y2: 318.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 370.6,
    y: 304.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,305.1v2h-14v-2H385.1 M386.1,304.1h-16v4h16V304.1L386.1,304.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 370.6,
    y: 328.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,329.1v2h-14v-2H385.1 M386.1,328.1h-16v4h16V328.1L386.1,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 373.6,
    y: 307.6,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.1,308.1v20h-8v-20H382.1 M383.1,307.1h-10v22h10V307.1L383.1,307.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,328.1c-1.8-2.6-2.8-6.4-2.8-9.9s1-7.3,2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,328.1c1.8-2.6,2.8-6.4,2.8-9.9s-1-7.3-2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.6,
    y: 307.6,
    width: 21,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,308.1v20h-20v-20H409.1 M410.1,307.1h-22v22h22V307.1L410.1,307.1z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.5,315.1h1.1l-2,5.7h-1l-2-5.7h1.1l1.5,4.5L400.5,315.1z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 399.1,
    y1: 307.1,
    x2: 399.1,
    y2: 301.1,
    fill: "none",
    stroke: "#000000"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 404.1,
    y1: 339.1,
    x2: 404.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.5,334.6 404.1,329.1 402.6,334.6"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 394.1,
    y1: 339.1,
    x2: 394.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.5,334.6 394.1,329.1 392.6,334.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 528.1,
    y1: 318.1,
    x2: 522.6,
    y2: 318.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 510.6,
    y: 304.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.1,305.1v2h-14v-2H525.1 M526.1,304.1h-16v4h16V304.1L526.1,304.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 510.6,
    y: 328.6,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.1,329.1v2h-14v-2H525.1 M526.1,328.1h-16v4h16V328.1L526.1,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 513.6,
    y: 307.6,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.1,308.1v20h-8v-20H522.1 M523.1,307.1h-10v22h10V307.1L523.1,307.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M522.7,328.1c-1.8-2.6-2.8-6.4-2.8-9.9s1-7.3,2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.6,328.1c1.8-2.6,2.8-6.4,2.8-9.9s-1-7.3-2.8-9.9",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 528.6,
    y: 307.6,
    width: 21,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.1,308.1v20h-20v-20H549.1 M550.1,307.1h-22v22h22V307.1L550.1,307.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M540.5,315.1h1.1l-2,5.7h-1l-2-5.7h1.1l1.5,4.5L540.5,315.1L540.5,315.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 544.1,
    y1: 339.1,
    x2: 544.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.5,334.6 544.1,329.1 542.7,334.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 534.1,
    y1: 339.1,
    x2: 534.1,
    y2: 333.6,
    fill: "none",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "535.5,334.6 534.1,329.1 532.7,334.6"
  })))));
};
export default SvgPHeatingSequenceMeter;